import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import PoolService from "../../services/pool.service";

/* =====================================================
   GET AUTO POOL STATUS
===================================================== */

export const getAutoPoolStatus = createAsyncThunk(
  "pool/getAutoPoolStatus",
  async (params = {}, thunkAPI) => {
    try {
      const response =
        await PoolService.getAutoPoolStatus(params);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.response?.data?.error?.message ||
        error.message ||
        "Failed to fetch auto pool status"
      );
    }
  }
);

/* =====================================================
   GET ALL AUTO POOL PAYMENT
===================================================== */

export const getAllAutoPoolPayment = createAsyncThunk(
  "pool/getAllAutoPoolPayment",
  async (params = {}, thunkAPI) => {
    try {
      const requestParams = {
        page:
          Number(params?.page) > 0
            ? Number(params.page)
            : 1,

        limit:
          Number(params?.limit) > 0
            ? Number(params.limit)
            : 25,
      };

      /* ================= SEARCH ================= */

      if (
        params?.search !== undefined &&
        params?.search !== null &&
        String(params.search).trim() !== ""
      ) {
        requestParams.search = String(params.search).trim();
      }

      /* ================= STATUS FILTER ================= */

      if (
        params?.status !== undefined &&
        params?.status !== null &&
        params?.status !== ""
      ) {
        requestParams.status = params.status;
      }

      /* ================= PAID POOL ================= */

      if (
        params?.paidPool !== undefined &&
        params?.paidPool !== null &&
        params?.paidPool !== ""
      ) {
        const paidPool = Number(params.paidPool);

        if (paidPool > 0) {
          requestParams.paidPool = paidPool;
        }
      }

      /* ================= DOWNLOAD ================= */

      if (
        params?.download !== undefined &&
        params?.download !== null
      ) {
        requestParams.download = Number(params.download) === 1 ? 1 : 0;
      }

      const response =
        await PoolService.getAllAutoPoolPayment(
          requestParams
        );

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.response?.data?.error?.message ||
        error.message ||
        "Failed to fetch auto pool payments"
      );
    }
  }
);
/* =====================================================
   PREPAY ELIGIBLE
===================================================== */

export const prepayeligible = createAsyncThunk(
  "pool/prepayeligible",
  async (params = {}, thunkAPI) => {
    try {
      const response =
        await PoolService.prepayeligible(params);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.response?.data?.error?.message ||
        error.message ||
        "Failed to fetch auto pool status"
      );
    }
  }
);

/* =====================================================
   GET AUTO POOL USERS
===================================================== */

export const getAutoPoolUsers = createAsyncThunk(
  "pool/getAutoPoolUsers",

  async (params = {}, thunkAPI) => {
    try {
      const requestParams = {
        page:
          Number(params?.page) > 0
            ? Number(params.page)
            : 1,

        limit:
          Number(params?.limit) > 0
            ? Number(params.limit)
            : 25,
      };

      /* ================= POOL ================= */

      if (
        params?.pool !== undefined &&
        params?.pool !== null &&
        params?.pool !== ""
      ) {
        requestParams.pool = params.pool;
      }

      /* ================= MATRIX CYCLE ================= */

      if (
        params?.matrixCycleId !== undefined &&
        params?.matrixCycleId !== null &&
        params?.matrixCycleId !== ""
      ) {
        requestParams.matrixCycleId =
          params.matrixCycleId;
      }

      /* ================= SEARCH ================= */

      if (
        params?.search !== undefined &&
        params?.search !== null &&
        String(params.search).trim() !== ""
      ) {
        requestParams.search =
          String(params.search).trim();
      }

      const response =
        await PoolService.getAutoPoolUsers(
          requestParams
        );

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.response?.data?.error?.message ||
        error.message ||
        "Failed to fetch auto pool users"
      );
    }
  }
);

/* =====================================================
   DISTRIBUTE POOL
===================================================== */

export const distributePool = createAsyncThunk(
  "pool/distributePool",

  async (payload, thunkAPI) => {
    try {
      const response =
        await PoolService.distributePool(
          payload
        );

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.response?.data?.error?.message ||
        error.message ||
        "Failed to distribute pool"
      );
    }
  }
);

/* =====================================================
   BULK PREPAY
===================================================== */

export const bulkprepay = createAsyncThunk(
  "pool/bulkprepay",

  async (payload, thunkAPI) => {
    try {
      const response =
        await PoolService.bulkprepay(
          payload
        );

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.response?.data?.error?.message ||
        error.message ||
        "Failed to process bulk pre-payment"
      );
    }
  }
);

/* =====================================================
   PRE PAY AUTO POOL
===================================================== */

export const prePayAutoPool = createAsyncThunk(
  "pool/prePayAutoPool",

  async (payload, thunkAPI) => {
    try {
      const response =
        await PoolService.prePayAutoPool(
          payload
        );

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message ||
        error.response?.data?.error?.message ||
        error.message ||
        "Failed to pre-pay auto pool"
      );
    }
  }
);

/* =====================================================
   INITIAL STATE
===================================================== */

const initialState = {
  /* ================= AUTO POOL STATUS ================= */

  autoPoolStatus: null,
  autoPoolStatusLoading: false,

  /* ================= AUTO POOL USERS ================= */

  autoPoolUsers: [],
  autoPoolUsersData: null,
  autoPoolUsersPagination: null,
  autoPoolUsersLoading: false,

  /* ================= AUTO POOL PAYMENTS ================= */

  autoPoolPayments: [],
  autoPoolPaymentsData: null,

  autoPoolPaymentsPagination: {
    total: 0,
    currentPage: 1,
    limit: 25,
    totalPages: 0,
    hasNextPage: false,
    hasPreviousPage: false,
  },

  autoPoolPaymentsLoading: false,
  autoPoolPaymentsError: null,

  /* ================= DISTRIBUTE POOL ================= */

  distributePoolLoading: false,
  distributePoolSuccess: false,
  distributePoolResponse: null,

  /* ================= PRE PAY AUTO POOL ================= */

  prePayAutoPoolLoading: false,
  prePayAutoPoolSuccess: false,
  prePayAutoPoolResponse: null,

  /* ================= PREPAY ELIGIBLE ================= */

  prepayEligible: null,
  prepayEligibleLoading: false,

  /* ================= COMMON ERROR ================= */

  error: null,
};

/* =====================================================
   SLICE
===================================================== */

const poolSlice = createSlice({
  name: "pool",

  initialState,

  reducers: {
    /* =================================================
       RESET DISTRIBUTE STATUS
    ================================================= */

    resetDistributePoolStatus: (state) => {
      state.distributePoolSuccess = false;
      state.distributePoolResponse = null;
    },

    /* =================================================
       RESET PRE PAY STATUS
    ================================================= */

    resetPrePayAutoPoolStatus: (state) => {
      state.prePayAutoPoolSuccess = false;
      state.prePayAutoPoolResponse = null;
    },

    /* =================================================
       RESET PREPAY ELIGIBLE
    ================================================= */

    resetPrepayEligible: (state) => {
      state.prepayEligible = null;
      state.prepayEligibleLoading = false;
    },

    /* =================================================
       CLEAR ERROR
    ================================================= */

    clearPoolError: (state) => {
      state.error = null;
      state.autoPoolPaymentsError = null;
    },

    /* =================================================
       CLEAR AUTO POOL USERS
    ================================================= */

    clearAutoPoolUsers: (state) => {
      state.autoPoolUsers = [];
      state.autoPoolUsersData = null;
      state.autoPoolUsersPagination = null;
    },

    /* =================================================
       CLEAR AUTO POOL PAYMENTS
    ================================================= */

    clearAutoPoolPayments: (state) => {
      state.autoPoolPayments = [];
      state.autoPoolPaymentsData = null;

      state.autoPoolPaymentsPagination = {
        total: 0,
        currentPage: 1,
        limit: 25,
        totalPages: 0,
        hasNextPage: false,
        hasPreviousPage: false,
      };

      state.autoPoolPaymentsError = null;
    },
  },

  /* =====================================================
     EXTRA REDUCERS
  ===================================================== */

  extraReducers: (builder) => {
    builder

      /* =====================================================
         GET AUTO POOL STATUS
      ===================================================== */

      .addCase(
        getAutoPoolStatus.pending,
        (state) => {
          state.autoPoolStatusLoading = true;
          state.error = null;
        }
      )

      .addCase(
        getAutoPoolStatus.fulfilled,
        (state, action) => {
          state.autoPoolStatusLoading = false;
          state.error = null;

          state.autoPoolStatus =
            action.payload?.data ||
            action.payload ||
            null;
        }
      )

      .addCase(
        getAutoPoolStatus.rejected,
        (state, action) => {
          state.autoPoolStatusLoading = false;

          state.error =
            action.payload ||
            "Failed to fetch auto pool status";

          state.autoPoolStatus = null;
        }
      )

      /* =====================================================
         PRE-PAY ELIGIBLE POOLS
      ===================================================== */

      .addCase(
        prepayeligible.pending,
        (state) => {
          state.prepayEligibleLoading = true;
          state.error = null;
        }
      )

      .addCase(
        prepayeligible.fulfilled,
        (state, action) => {
          state.prepayEligibleLoading = false;
          state.error = null;

          state.prepayEligible =
            action.payload?.data ||
            action.payload ||
            null;
        }
      )

      .addCase(
        prepayeligible.rejected,
        (state, action) => {
          state.prepayEligibleLoading = false;

          state.error =
            action.payload ||
            "Failed to fetch eligible pre-payment pools";

          state.prepayEligible = null;
        }
      )

      /* =====================================================
         GET ALL AUTO POOL PAYMENTS - PENDING
      ===================================================== */

      .addCase(
        getAllAutoPoolPayment.pending,
        (state) => {
          state.autoPoolPaymentsLoading = true;
          state.autoPoolPaymentsError = null;
          state.error = null;
        }
      )

      /* =====================================================
         GET ALL AUTO POOL PAYMENTS - SUCCESS
      ===================================================== */

      .addCase(
        getAllAutoPoolPayment.fulfilled,
        (state, action) => {
          state.autoPoolPaymentsLoading = false;
          state.autoPoolPaymentsError = null;

          const response = action.payload || {};

          const data =
            response?.data || response;

          state.autoPoolPayments =
            Array.isArray(data?.records)
              ? data.records
              : [];

          const pagination =
            data?.pagination || {};

          state.autoPoolPaymentsPagination = {
            totalRecords:
              Number(
                pagination?.totalRecords
              ) || 0,

            currentPage:
              Number(
                pagination?.currentPage
              ) || 1,

            limit:
              Number(
                pagination?.limit
              ) || 25,

            totalPages:
              Number(
                pagination?.totalPages
              ) || 0,

            hasNextPage:
              Boolean(
                pagination?.hasNextPage
              ),

            hasPreviousPage:
              Boolean(
                pagination?.hasPreviousPage
              ),
          };
        }
      )

      /* =====================================================
         GET ALL AUTO POOL PAYMENTS - ERROR
      ===================================================== */

      .addCase(
        getAllAutoPoolPayment.rejected,
        (state, action) => {
          state.autoPoolPaymentsLoading = false;

          state.autoPoolPaymentsError =
            action.payload ||
            "Failed to fetch auto pool payments";

          state.error =
            action.payload ||
            "Failed to fetch auto pool payments";

          state.autoPoolPayments = [];
          state.autoPoolPaymentsData = null;
        }
      )

      /* =====================================================
         GET AUTO POOL USERS - PENDING
      ===================================================== */

      .addCase(
        getAutoPoolUsers.pending,
        (state) => {
          state.autoPoolUsersLoading = true;
          state.error = null;
        }
      )

      /* =====================================================
         GET AUTO POOL USERS - SUCCESS
      ===================================================== */

      .addCase(
        getAutoPoolUsers.fulfilled,
        (state, action) => {
          state.autoPoolUsersLoading = false;
          state.error = null;

          const response =
            action.payload || {};

          state.autoPoolUsers =
            Array.isArray(
              response.data
            )
              ? response.data
              : [];

          state.autoPoolUsersData =
            response;

          state.autoPoolUsersPagination =
            response.pagination ||
            null;
        }
      )

      /* =====================================================
         GET AUTO POOL USERS - ERROR
      ===================================================== */

      .addCase(
        getAutoPoolUsers.rejected,
        (state, action) => {
          state.autoPoolUsersLoading = false;

          state.error =
            action.payload ||
            "Failed to fetch auto pool users";

          state.autoPoolUsers = [];

          state.autoPoolUsersData = null;

          state.autoPoolUsersPagination =
            null;
        }
      )

      /* =====================================================
         DISTRIBUTE POOL - PENDING
      ===================================================== */

      .addCase(
        distributePool.pending,
        (state) => {
          state.distributePoolLoading = true;
          state.distributePoolSuccess = false;
          state.distributePoolResponse = null;
          state.error = null;
        }
      )

      /* =====================================================
         DISTRIBUTE POOL - SUCCESS
      ===================================================== */

      .addCase(
        distributePool.fulfilled,
        (state, action) => {
          state.distributePoolLoading = false;
          state.distributePoolSuccess = true;
          state.error = null;

          state.distributePoolResponse =
            action.payload?.data ||
            action.payload ||
            null;
        }
      )

      /* =====================================================
         DISTRIBUTE POOL - ERROR
      ===================================================== */

      .addCase(
        distributePool.rejected,
        (state, action) => {
          state.distributePoolLoading = false;
          state.distributePoolSuccess = false;

          state.error =
            action.payload ||
            "Failed to distribute pool";

          state.distributePoolResponse =
            null;
        }
      )

      /* =====================================================
         PRE PAY AUTO POOL - PENDING
      ===================================================== */

      .addCase(
        prePayAutoPool.pending,
        (state) => {
          state.prePayAutoPoolLoading = true;
          state.prePayAutoPoolSuccess = false;
          state.prePayAutoPoolResponse = null;
          state.error = null;
        }
      )

      /* =====================================================
         PRE PAY AUTO POOL - SUCCESS
      ===================================================== */

      .addCase(
        prePayAutoPool.fulfilled,
        (state, action) => {
          state.prePayAutoPoolLoading = false;
          state.prePayAutoPoolSuccess = true;
          state.error = null;

          state.prePayAutoPoolResponse =
            action.payload?.data ||
            action.payload ||
            null;
        }
      )

      /* =====================================================
         PRE PAY AUTO POOL - ERROR
      ===================================================== */

      .addCase(
        prePayAutoPool.rejected,
        (state, action) => {
          state.prePayAutoPoolLoading = false;
          state.prePayAutoPoolSuccess = false;

          state.error =
            action.payload ||
            "Failed to pre-pay auto pool";

          state.prePayAutoPoolResponse =
            null;
        }
      );
  },
});

/* =====================================================
   ACTIONS
===================================================== */

export const {
  resetDistributePoolStatus,
  resetPrePayAutoPoolStatus,
  resetPrepayEligible,
  clearPoolError,
  clearAutoPoolUsers,
  clearAutoPoolPayments,
} = poolSlice.actions;

/* =====================================================
   REDUCER
===================================================== */

export default poolSlice.reducer;